// extracted by css-extract-rspack-plugin
export default {"title":"title--Fc8Np9DwF45PHTwe","titleText":"title-text--eZ8eKdNAB8s5e9pP"};